var Icon;
(function (Icon) {
    Icon["AbleForAll"] = "icon-able-for-all";
    Icon["Able"] = "icon-able";
    Icon["Activity"] = "icon-activity";
    Icon["Adventurous"] = "icon-adventurous";
    Icon["Airplane"] = "icon-airplane";
    Icon["Bank"] = "icon-bank";
    Icon["CalendarLine"] = "icon-calendar-line";
    Icon["Calendar"] = "icon-calendar";
    Icon["CardCrossedout"] = "icon-card-crossedout";
    Icon["Card"] = "icon-card";
    Icon["Cautious"] = "icon-cautious";
    Icon["ChangeReversal"] = "icon-change-reversal";
    Icon["CheckmarkRounded"] = "icon-checkmark-rounded";
    Icon["Checkmark"] = "icon-checkmark";
    Icon["CircleAble"] = "icon-circle-able";
    Icon["CircleAirplane"] = "icon-circle-airplane";
    Icon["CircleBank"] = "icon-circle-bank";
    Icon["CircleCalculator"] = "icon-circle-calculator";
    Icon["CircleCalendarLine"] = "icon-circle-calendar-line";
    Icon["CircleCalendar"] = "icon-circle-calendar";
    Icon["CircleCardCrossedout"] = "icon-circle-card-crossedout";
    Icon["CircleCard"] = "icon-circle-card";
    Icon["CircleCheckmark"] = "icon-circle-checkmark";
    Icon["CircleCoffee"] = "icon-circle-coffee";
    Icon["CircleDeposit"] = "icon-circle-deposit";
    Icon["CircleDividend"] = "icon-circle-dividend";
    Icon["CircleDocument"] = "icon-circle-document";
    Icon["CircleError"] = "icon-circle-error";
    Icon["CircleFacebook"] = "icon-circle-facebook";
    Icon["CircleGift"] = "icon-circle-gift";
    Icon["CircleGoogleplus"] = "icon-circle-googleplus";
    Icon["CircleGraduationCap"] = "icon-circle-graduation-cap";
    Icon["CircleHeart"] = "icon-circle-heart";
    Icon["CircleHourglass"] = "icon-circle-hourglass";
    Icon["CircleHouse"] = "icon-circle-house";
    Icon["CircleInstagram"] = "icon-circle-instagram";
    Icon["CircleInvestment"] = "icon-circle-investment";
    Icon["CircleLinked"] = "icon-circle-linked";
    Icon["CircleLotDepletion"] = "icon-circle-lot-depletion";
    Icon["CircleMail"] = "icon-circle-mail";
    Icon["CircleMegaphone"] = "icon-circle-megaphone";
    Icon["CircleMinus"] = "icon-circle-minus";
    Icon["CircleMoneyBag"] = "icon-circle-money-bag";
    Icon["CirclePhone"] = "icon-circle-phone";
    Icon["CirclePiggyBank"] = "icon-circle-piggy-bank";
    Icon["CirclePlus"] = "icon-circle-plus";
    Icon["CirclePortfolio"] = "icon-circle-portfolio";
    Icon["CircleReallocation"] = "icon-circle-reallocation";
    Icon["CircleRebalance"] = "icon-circle-rebalance";
    Icon["CircleRightCaret"] = "icon-circle-right-caret";
    Icon["CircleSumdayMark"] = "icon-circle-sumday-mark";
    Icon["CircleSunset"] = "icon-circle-sunset";
    Icon["CircleTwitter"] = "icon-circle-twitter";
    Icon["CircleUmbrella"] = "icon-circle-umbrella";
    Icon["CircleWithdrawal"] = "icon-circle-withdrawal";
    Icon["CircleWrench"] = "icon-circle-wrench";
    Icon["Circle"] = "icon-circle";
    Icon["CloseRounded"] = "icon-close-rounded";
    Icon["Close"] = "icon-close";
    Icon["Coffee"] = "icon-coffee";
    Icon["Collapse"] = "icon-collapse";
    Icon["Contact"] = "icon-contact";
    Icon["DecreaseReversal"] = "icon-decrease-reversal";
    Icon["Decrease"] = "icon-decrease";
    Icon["Deposit"] = "icon-deposit";
    Icon["Dividend"] = "icon-dividend";
    Icon["Document"] = "icon-document";
    Icon["DownCaret"] = "icon-down-caret";
    Icon["Download"] = "icon-download";
    Icon["EasyGoing"] = "icon-easy-going";
    Icon["Edit"] = "icon-edit";
    Icon["Error"] = "icon-error";
    Icon["Expand"] = "icon-expand";
    Icon["Facebook"] = "icon-facebook";
    Icon["Faqs"] = "icon-faqs";
    Icon["Female"] = "icon-female";
    Icon["Filter"] = "icon-filter";
    Icon["FocusCaret"] = "icon-focus-caret";
    Icon["Get"] = "icon-get";
    Icon["GiftPig"] = "icon-gift-pig";
    Icon["Gift"] = "icon-gift";
    Icon["Googleplus"] = "icon-googleplus";
    Icon["GraduationCap"] = "icon-graduation-cap";
    Icon["Hamburger"] = "icon-hamburger";
    Icon["Heart"] = "icon-heart";
    Icon["Help"] = "icon-help";
    Icon["HistoricalNav"] = "icon-historical-nav";
    Icon["Hourglass"] = "icon-hourglass";
    Icon["House"] = "icon-house";
    Icon["IncreaseReversal"] = "icon-increase-reversal";
    Icon["Increase"] = "icon-increase";
    Icon["Info"] = "icon-info";
    Icon["Instagram"] = "icon-instagram";
    Icon["InvertedCircleEdit"] = "icon-inverted-circle-edit";
    Icon["InvertedCircleFacebook"] = "icon-inverted-circle-facebook";
    Icon["InvertedCircleGoogleplus"] = "icon-inverted-circle-googleplus";
    Icon["InvertedCircleInfo"] = "icon-inverted-circle-info";
    Icon["InvertedCircleInstagram"] = "icon-inverted-circle-instagram";
    Icon["InvertedCircleLock"] = "icon-inverted-circle-lock";
    Icon["InvertedCircleMail"] = "icon-inverted-circle-mail";
    Icon["InvertedCircleMinus"] = "icon-inverted-circle-minus";
    Icon["InvertedCirclePaperAirplane"] = "icon-inverted-circle-paper-airplane";
    Icon["InvertedCirclePause"] = "icon-inverted-circle-pause";
    Icon["InvertedCirclePhone"] = "icon-inverted-circle-phone";
    Icon["InvertedCirclePlay"] = "icon-inverted-circle-play";
    Icon["InvertedCirclePlus"] = "icon-inverted-circle-plus";
    Icon["InvertedCirclePrint"] = "icon-inverted-circle-print";
    Icon["InvertedCircleQuestionMark"] = "icon-inverted-circle-question-mark";
    Icon["InvertedCircleTrashCan"] = "icon-inverted-circle-trash-can";
    Icon["InvertedCircleTwitter"] = "icon-inverted-circle-twitter";
    Icon["Investment"] = "icon-investment";
    Icon["LeftCaret"] = "icon-left-caret";
    Icon["LightInvertedCircleCheckmark"] = "icon-light-inverted-circle-checkmark";
    Icon["LightInvertedCircleError"] = "icon-light-inverted-circle-error";
    Icon["LightInvertedCircleHourglass"] = "icon-light-inverted-circle-hourglass";
    Icon["Lightbulb"] = "icon-lightbulb";
    Icon["Link"] = "icon-link";
    Icon["Loading"] = "icon-loading";
    Icon["Lock"] = "icon-lock";
    Icon["Mail"] = "icon-mail";
    Icon["Male"] = "icon-male";
    Icon["Megaphone"] = "icon-megaphone";
    Icon["Minus"] = "icon-minus";
    Icon["MoneyBag"] = "icon-money-bag";
    Icon["NewWindow"] = "icon-new-window";
    Icon["Next"] = "icon-next";
    Icon["OregonAble"] = "icon-oregon-able";
    Icon["PaperAirplane"] = "icon-paper-airplane";
    Icon["Pause"] = "icon-pause";
    Icon["Phone"] = "icon-phone";
    Icon["PiggyBank"] = "icon-piggy-bank";
    Icon["Play"] = "icon-play";
    Icon["Plus"] = "icon-plus";
    Icon["Pointer"] = "icon-pointer";
    Icon["Portfolio"] = "icon-portfolio";
    Icon["Print"] = "icon-print";
    Icon["QuestionMark"] = "icon-question-mark";
    Icon["Reallocation"] = "icon-reallocation";
    Icon["Rebalance"] = "icon-rebalance";
    Icon["Refresh"] = "icon-refresh";
    Icon["RightCaret"] = "icon-right-caret";
    Icon["Search"] = "icon-search";
    Icon["Settings"] = "icon-settings";
    Icon["SmileyFace"] = "icon-smiley-face";
    Icon["SumdayMark"] = "icon-sumday-mark";
    Icon["Sunset"] = "icon-sunset";
    Icon["Transfer"] = "icon-transfer";
    Icon["TrashCan"] = "icon-trash-can";
    Icon["Trigger"] = "icon-trigger";
    Icon["Twitter"] = "icon-twitter";
    Icon["Umbrella"] = "icon-umbrella";
    Icon["Undo"] = "icon-undo";
    Icon["Unlink"] = "icon-unlink";
    Icon["UpCaret"] = "icon-up-caret";
    Icon["UploadCheck"] = "icon-upload-check";
    Icon["UploadPlus"] = "icon-upload-plus";
    Icon["UploadSelected"] = "icon-upload-selected";
    Icon["Upload"] = "icon-upload";
    Icon["User"] = "icon-user";
    Icon["Visibility"] = "icon-visibility";
    Icon["Withdrawal"] = "icon-withdrawal";
    Icon["Wrench"] = "icon-wrench";
})(Icon || (Icon = {}));

var Color;
(function (Color) {
    Color["Plum"] = "#403947";
    Color["MediumPlum"] = "#6b6475";
    Color["LightPlum"] = "#a5a0aa";
    Color["Blue"] = "#007ca5";
    Color["MediumBlue"] = "#1c6caf";
    Color["DarkBlue"] = "#005c75";
    Color["Pink"] = "#d13673";
    Color["MediumPink"] = "#af256a";
    Color["Green"] = "#338200";
    Color["DarkGreen"] = "#245b00";
    Color["Orange"] = "#fa830a";
    Color["YellowOrange"] = "#ffa000";
    Color["Red"] = "#d90a36";
    Color["DarkRed"] = "#b3092d";
    Color["FadedRed"] = "#fbe6eb";
    Color["StormGray"] = "#e3e7e9";
    Color["Black"] = "#000";
    Color["White"] = "#fff";
    Color["White_50"] = "rgba(255, 255, 255, .5)";
    Color["Disabled"] = "#a5a0aa";
    Color["DisabledBg"] = "#f3f3f3";
    Color["Divider"] = "#efeef0";
    Color["DividerBg"] = "#fbfbfb";
    Color["DisabledBlade"] = "#f5f7fc";
    Color["EnabledBlade"] = "#edf8fc";
    Color["ActiveBlade"] = "#e1f4fc";
    Color["FacebookPrimary"] = "#4862a0";
    Color["InstagramPrimary"] = "#19557e";
    Color["TwitterPrimary"] = "#0e9af1";
    Color["WashingtonGetPrimary"] = "#007a41";
    Color["BaseFontColor"] = "#403947";
    Color["ActionColor"] = "#007ca5";
    Color["BaseBorderColor"] = "#efeef0";
    Color["ChartColor_1"] = "#00617C";
    Color["ChartColor_2"] = "#389CBD";
    Color["ChartColor_3"] = "#B2DAE7";
    Color["ChartColor_4"] = "#4C316C";
    Color["ChartColor_5"] = "#806A9A";
    Color["ChartColor_6"] = "#CEC1DC";
    Color["ChartColor_7"] = "#22470B";
    Color["ChartColor_8"] = "#4A8821";
    Color["ChartColor_9"] = "#9CB989";
    Color["ChartColor_10"] = "#750B50";
    Color["ChartColor_11"] = "#BB378D";
    Color["ChartColor_12"] = "#E3B7D2";
    Color["ChartColor_13"] = "#C37D00";
    Color["ChartColor_14"] = "#FFBD00";
    Color["ChartColor_15"] = "#FFE8A6";
})(Color || (Color = {}));

var ColorVar;
(function (ColorVar) {
    ColorVar["Plum"] = "$plum";
    ColorVar["MediumPlum"] = "$medium-plum";
    ColorVar["LightPlum"] = "$light-plum";
    ColorVar["Blue"] = "$blue";
    ColorVar["MediumBlue"] = "$medium-blue";
    ColorVar["DarkBlue"] = "$dark-blue";
    ColorVar["Pink"] = "$pink";
    ColorVar["MediumPink"] = "$medium-pink";
    ColorVar["Green"] = "$green";
    ColorVar["DarkGreen"] = "$dark-green";
    ColorVar["Orange"] = "$orange";
    ColorVar["YellowOrange"] = "$yellow-orange";
    ColorVar["Red"] = "$red";
    ColorVar["DarkRed"] = "$dark-red";
    ColorVar["FadedRed"] = "$faded-red";
    ColorVar["StormGray"] = "$storm-gray";
    ColorVar["Black"] = "$black";
    ColorVar["White"] = "$white";
    ColorVar["White_50"] = "$white-50";
    ColorVar["Disabled"] = "$disabled";
    ColorVar["DisabledBg"] = "$disabled-bg";
    ColorVar["Divider"] = "$divider";
    ColorVar["DividerBg"] = "$divider-bg";
    ColorVar["DisabledBlade"] = "$disabled-blade";
    ColorVar["EnabledBlade"] = "$enabled-blade";
    ColorVar["ActiveBlade"] = "$active-blade";
    ColorVar["FacebookPrimary"] = "$facebook-primary";
    ColorVar["InstagramPrimary"] = "$instagram-primary";
    ColorVar["TwitterPrimary"] = "$twitter-primary";
    ColorVar["WashingtonGetPrimary"] = "$washington-get-primary";
    ColorVar["BaseFontColor"] = "$base-font-color";
    ColorVar["ActionColor"] = "$action-color";
    ColorVar["BaseBorderColor"] = "$base-border-color";
    ColorVar["ChartColor_1"] = "$chart-color-1";
    ColorVar["ChartColor_2"] = "$chart-color-2";
    ColorVar["ChartColor_3"] = "$chart-color-3";
    ColorVar["ChartColor_4"] = "$chart-color-4";
    ColorVar["ChartColor_5"] = "$chart-color-5";
    ColorVar["ChartColor_6"] = "$chart-color-6";
    ColorVar["ChartColor_7"] = "$chart-color-7";
    ColorVar["ChartColor_8"] = "$chart-color-8";
    ColorVar["ChartColor_9"] = "$chart-color-9";
    ColorVar["ChartColor_10"] = "$chart-color-10";
    ColorVar["ChartColor_11"] = "$chart-color-11";
    ColorVar["ChartColor_12"] = "$chart-color-12";
    ColorVar["ChartColor_13"] = "$chart-color-13";
    ColorVar["ChartColor_14"] = "$chart-color-14";
    ColorVar["ChartColor_15"] = "$chart-color-15";
})(ColorVar || (ColorVar = {}));

var Theme;
(function (Theme) {
    Theme["PrimaryBrandColor"] = "color-variables.$blue";
    Theme["PrimaryBrandHoverColor"] = "#09NaNNaN";
    Theme["PrimaryButtonColor"] = "color-variables.$blue";
    Theme["PrimaryButtonHoverColor"] = "#09NaNNaN";
    Theme["PrimaryLinkTextColor"] = "color-variables.$blue";
    Theme["PrimaryLinkHoverTextColor"] = "#09NaNNaN";
    Theme["BaseFontScale"] = "62.5%";
    Theme["BaseFontSize"] = "variables.$base-font-size";
    Theme["BaseLineHeight"] = "variables.$base-line-height";
    Theme["BaseFontColor"] = "color-variables.$plum";
    Theme["BaseLighterTextColor"] = "color-variables.$medium-plum";
    Theme["BaseBorderRadius"] = "variables.$base-border-radius";
    Theme["BaseFontFamily"] = "variables.$base-font-family";
    Theme["BaseHeadingFontFamily"] = "variables.$heading-font-family";
    Theme["BaseGridSpace"] = "10px";
    Theme["BaseBorderColor"] = "color-variables.$base-border-color";
    Theme["BaseThBorderColor"] = "#09NaNNaN";
    Theme["FormControlTextColor"] = "color-variables.$plum";
    Theme["FormControlBorderColor"] = "color-variables.$plum";
    Theme["FormControlFocusColor"] = "color-variables.$blue";
    Theme["FormControlToggleActiveColor"] = "color-variables.$blue";
    Theme["HeaderLinkTextColor"] = "color-variables.$plum";
    Theme["HeaderActiveLinkTextColor"] = "color-variables.$pink";
    Theme["FooterBackgroundColor"] = "color-variables.$medium-plum";
    Theme["FooterTextColor"] = "color-variables.$white";
    Theme["FooterLinkColor"] = "color-variables.$white";
    Theme["FooterPlanPickerBackgroundColor"] = "color-variables.$plum";
    Theme["FooterPlanPickerTextColor"] = "color-variables.$white";
    Theme["FooterPlanPickerLinkColor"] = "color-variables.$white";
    Theme["FooterPlanBackgroundColor"] = "color-variables.$white";
    Theme["FooterPlanTextColor"] = "color-variables.$plum";
    Theme["FooterPlanLinkColor"] = "color-variables.$medium-plum";
    Theme["FooterPlanLinkHoverColor"] = "#09NaNNaN";
    Theme["LoaderColor_1"] = "color-variables.$plum";
    Theme["LoaderColor_2"] = "color-variables.$green";
    Theme["LoaderColor_3"] = "color-variables.$blue";
    Theme["LoaderColor_4"] = "color-variables.$pink";
    Theme["ChartColor_1"] = "color-variables.$chart-color-1";
    Theme["ChartColor_2"] = "color-variables.$chart-color-2";
    Theme["ChartColor_3"] = "color-variables.$chart-color-3";
    Theme["ChartColor_4"] = "color-variables.$chart-color-4";
    Theme["ChartColor_5"] = "color-variables.$chart-color-5";
    Theme["ChartColor_6"] = "color-variables.$chart-color-6";
    Theme["ChartColor_7"] = "color-variables.$chart-color-7";
    Theme["ChartColor_8"] = "color-variables.$chart-color-8";
    Theme["ChartColor_9"] = "color-variables.$chart-color-9";
    Theme["ChartColor_10"] = "color-variables.$chart-color-10";
    Theme["ChartColor_11"] = "color-variables.$chart-color-11";
    Theme["ChartColor_12"] = "color-variables.$chart-color-12";
    Theme["ChartColor_13"] = "color-variables.$chart-color-13";
    Theme["ChartColor_14"] = "color-variables.$chart-color-14";
    Theme["ChartColor_15"] = "color-variables.$chart-color-15";
    Theme["TablistActiveBackgroundColor"] = "color-variables.$plum";
})(Theme || (Theme = {}));

var ThemeVar;
(function (ThemeVar) {
    ThemeVar["PrimaryBrandColor"] = "--primary-brand-color";
    ThemeVar["PrimaryBrandHoverColor"] = "--primary-brand-hover-color";
    ThemeVar["PrimaryButtonColor"] = "--primary-button-color";
    ThemeVar["PrimaryButtonHoverColor"] = "--primary-button-hover-color";
    ThemeVar["PrimaryLinkTextColor"] = "--primary-link-text-color";
    ThemeVar["PrimaryLinkHoverTextColor"] = "--primary-link-hover-text-color";
    ThemeVar["BaseFontScale"] = "--base-font-scale";
    ThemeVar["BaseFontSize"] = "--base-font-size";
    ThemeVar["BaseLineHeight"] = "--base-line-height";
    ThemeVar["BaseFontColor"] = "--base-font-color";
    ThemeVar["BaseLighterTextColor"] = "--base-lighter-text-color";
    ThemeVar["BaseBorderRadius"] = "--base-border-radius";
    ThemeVar["BaseFontFamily"] = "--base-font-family";
    ThemeVar["BaseHeadingFontFamily"] = "--base-heading-font-family";
    ThemeVar["BaseGridSpace"] = "--base-grid-space";
    ThemeVar["BaseBorderColor"] = "--base-border-color";
    ThemeVar["BaseThBorderColor"] = "--base-th-border-color";
    ThemeVar["FormControlTextColor"] = "--form-control-text-color";
    ThemeVar["FormControlBorderColor"] = "--form-control-border-color";
    ThemeVar["FormControlFocusColor"] = "--form-control-focus-color";
    ThemeVar["FormControlToggleActiveColor"] = "--form-control-toggle-active-color";
    ThemeVar["HeaderLinkTextColor"] = "--header-link-text-color";
    ThemeVar["HeaderActiveLinkTextColor"] = "--header-active-link-text-color";
    ThemeVar["FooterBackgroundColor"] = "--footer-background-color";
    ThemeVar["FooterTextColor"] = "--footer-text-color";
    ThemeVar["FooterLinkColor"] = "--footer-link-color";
    ThemeVar["FooterPlanPickerBackgroundColor"] = "--footer-plan-picker-background-color";
    ThemeVar["FooterPlanPickerTextColor"] = "--footer-plan-picker-text-color";
    ThemeVar["FooterPlanPickerLinkColor"] = "--footer-plan-picker-link-color";
    ThemeVar["FooterPlanBackgroundColor"] = "--footer-plan-background-color";
    ThemeVar["FooterPlanTextColor"] = "--footer-plan-text-color";
    ThemeVar["FooterPlanLinkColor"] = "--footer-plan-link-color";
    ThemeVar["FooterPlanLinkHoverColor"] = "--footer-plan-link-hover-color";
    ThemeVar["LoaderColor_1"] = "--loader-color-1";
    ThemeVar["LoaderColor_2"] = "--loader-color-2";
    ThemeVar["LoaderColor_3"] = "--loader-color-3";
    ThemeVar["LoaderColor_4"] = "--loader-color-4";
    ThemeVar["ChartColor_1"] = "--chart-color-1";
    ThemeVar["ChartColor_2"] = "--chart-color-2";
    ThemeVar["ChartColor_3"] = "--chart-color-3";
    ThemeVar["ChartColor_4"] = "--chart-color-4";
    ThemeVar["ChartColor_5"] = "--chart-color-5";
    ThemeVar["ChartColor_6"] = "--chart-color-6";
    ThemeVar["ChartColor_7"] = "--chart-color-7";
    ThemeVar["ChartColor_8"] = "--chart-color-8";
    ThemeVar["ChartColor_9"] = "--chart-color-9";
    ThemeVar["ChartColor_10"] = "--chart-color-10";
    ThemeVar["ChartColor_11"] = "--chart-color-11";
    ThemeVar["ChartColor_12"] = "--chart-color-12";
    ThemeVar["ChartColor_13"] = "--chart-color-13";
    ThemeVar["ChartColor_14"] = "--chart-color-14";
    ThemeVar["ChartColor_15"] = "--chart-color-15";
    ThemeVar["TablistActiveBackgroundColor"] = "--tablist-active-background-color";
})(ThemeVar || (ThemeVar = {}));

var Breakpoint;
(function (Breakpoint) {
    Breakpoint["Mobile"] = "(max-width: 599px)";
    Breakpoint["GreaterThanMobile"] = "(min-width: 600px)";
    Breakpoint["Tablet"] = "(min-width: 600px) and (max-width: 959px)";
    Breakpoint["GreaterThanTablet"] = "(min-width: 960px)";
    Breakpoint["LessThanDesktop"] = "(max-width: 959px)";
    Breakpoint["Desktop"] = "(min-width: 960px)";
    Breakpoint["Xl"] = "(min-width: 1440px)";
})(Breakpoint || (Breakpoint = {}));

var Variables;
(function (Variables) {
    Variables["GridSpace"] = "10px";
    Variables["GridGutter"] = "$grid-space * 2";
    Variables["MaxWidth"] = "1280px";
    Variables["MaxWidthWithGutter"] = "($max-width + $grid-gutter)";
    Variables["HeaderHeight"] = "45px";
    Variables["HeaderBorderColor"] = "rgb(227, 231, 233)";
    Variables["HeaderLogoMobileSize"] = "15px";
    Variables["HeaderPaddingTop"] = "12px";
    Variables["DropShadow"] = "0 2px 4px 0 rgba(218, 218, 218, 0.5)";
    Variables["RiseShadow"] = "0 -2px 4px 0 rgba(218, 218, 218, 0.5)";
    Variables["FooterNavbarHeight"] = "60px";
    Variables["BaseFontFamily"] = "\"Source Sans Pro\", sans-serif";
    Variables["HeadingFontFamily"] = "\"Source Sans Pro\", sans-serif";
    Variables["BaseFontSize"] = "1.6rem";
    Variables["BaseLineHeight"] = "1.2";
    Variables["HeadingLineHeight"] = "1.2";
    Variables["BaseBorderRadius"] = "5px";
    Variables["BaseSpacing"] = "$base-line-height * 1em";
    Variables["SmallSpacing"] = "$base-spacing / 2";
    Variables["BaseZIndex"] = "0";
    Variables["DesktopTopNavHeight"] = "151px";
    Variables["DesktopBottomContactBarHeight"] = "70px";
    Variables["ButtonContainerSpacing"] = "10px";
    Variables["FocusBorderWidth"] = "1px";
    Variables["CurrencyMaxWidth"] = "175px";
    Variables["BladeElementSpacing"] = "10px";
    Variables["BladeLabelWidth"] = "70px";
    Variables["BladeHeight"] = "6rem";
    Variables["BladeInputLeft"] = "90px";
    Variables["ProgramIconSizeSmall"] = "21px";
    Variables["ProgramIconSizeLarge"] = "45px";
    Variables["BaseBorder"] = "1px solid var(--base-border-color)";
    Variables["BaseBackgroundColor"] = "color-variables.$white";
    Variables["SecondaryBackgroundColor"] = "color-variables.$disabled-blade";
    Variables["BaseDuration"] = "150ms";
    Variables["BaseTiming"] = "ease";
    Variables["DetailColumnZ"] = "99999999";
    Variables["MobileModalNavbarZ"] = "999999";
    Variables["OptionsColumnZ"] = "99999";
    Variables["TakeoverModalZ"] = "99999";
    Variables["TooltipZ"] = "99998";
    Variables["ContentMaxWidth"] = "440px";
})(Variables || (Variables = {}));

/*
 * Public API Surface of assets
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Breakpoint, Color, ColorVar, Icon, Theme, ThemeVar, Variables };
